<script lang="ts">
  export let classNames: string = "";
</script>

<div class={"content-container " + classNames}>
  <slot />
</div>

<style lang="scss">
  .content-container {
    margin-top: 1rem;
    margin-bottom: 1rem;

    border-radius: 9px;
    border-color: #d0d0d0;
    border-width: 4px;
    border-style: ridge;

    background: rgb(44, 50, 64);
    background: linear-gradient(
      180deg,
      rgba(44, 50, 64, 1) 0,
      rgba(91, 100, 117, 1) 180px,
      rgba(91, 100, 117, 1) 100%
    );

    padding: 1rem;
  }
</style>
